export default "<div class=\"col__container\" ng-class=\"::$ctrl.style.container\">\n  <p class=\"text-ink-900 m-0\" ng-bind=\"$ctrl.easyId\"></p>\n</div>\n"